// extracted by mini-css-extract-plugin
export default {"item":"_BIk2","inner":"twhgL","tag":"GkaBb"};